import React, { ReactNode } from 'react';
import styles from './index.module.css';

interface IProps {
	children: ReactNode;
}

export const MerchantPageByLinkContainer = ({children}: IProps) => (
	<div className={styles.container}>
		{children}
	</div>
);
